import { useQuery } from '@tanstack/react-query';
import { templateLibraryApi } from '../api';

/**
 * Query key factory for system template library
 */
export const templateLibraryQueryKeys = {
  all: ['system-templates'] as const,
  filtered: (type?: string) => ['system-templates', type] as const,
};

/**
 * Hook to fetch system templates from library
 * @param templateType - Optional filter by template type
 * @returns React Query result with system templates
 */
export function useSystemTemplates(templateType?: string) {
  return useQuery({
    queryKey: templateLibraryQueryKeys.filtered(templateType !== 'all' ? templateType : undefined),
    queryFn: () => templateLibraryApi.getSystemTemplates(templateType),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

